import { esES } from "@mui/x-data-grid";

/**
 * Estilo común de los DataGrid de escritorio
 *
 * Fuente única de verdad para todos los features, igual que badgeColors.js para
 * los chips. Son constantes de módulo: no se recrean en cada render.
 *
 * DECISION (homogeneización oct 2026): las celdas van a 13px. Era el tamaño que
 * ya usaban casi todas las columnas con renderCell, mientras que las columnas de
 * texto plano salían a los 14px por defecto de MUI: en una misma fila convivían
 * dos tamaños de letra. Fijándolo aquí, un renderCell con Typography a 13 y una
 * celda plana se ven iguales.
 *
 * Para añadir claves propias (filas coloreadas, celdas multilínea) se extiende:
 *   sx={{ ...DATA_GRID_SX, "& .mi-clase": { ... } }}
 * Lo que no se hace es quitar las comunes.
 */

/** Textos en español del DataGrid */
export const DATA_GRID_LOCALE_TEXT = esES.components.MuiDataGrid.defaultProps.localeText;

/** Paginación por defecto: 10 filas */
export const DATA_GRID_INITIAL_STATE = { pagination: { paginationModel: { pageSize: 10 } } };

/** Opciones de tamaño de página por defecto */
export const DATA_GRID_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/** Overlay de carga en el rojo corporativo (sin esto sale azul MUI) */
export const DATA_GRID_SLOT_PROPS = {
    loadingOverlay: { sx: { "& .MuiCircularProgress-root": { color: "#cc071e" } } },
};

/** Tamaños de letra dentro de las celdas, para los renderCell */
export const DATA_GRID_FONT_SIZE = {
    CELDA: 13,       // Texto principal de la celda
    SECUNDARIO: 12,  // Segunda línea, texto auxiliar
};

/** Aspecto común: borde suave, cabecera gris con títulos en negrita, hover gris */
export const DATA_GRID_SX = {
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: 2,
    "& .MuiDataGrid-cell": {
        borderColor: "rgba(0,0,0,0.05)",
        fontSize: DATA_GRID_FONT_SIZE.CELDA,
    },
    "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid rgba(0,0,0,0.1)",
    },
    "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 700, color: "#495057" },
    "& .MuiDataGrid-row:hover": { backgroundColor: "#f8f9fa" },
};
